import styled from "@emotion/styled";
import { border } from "@smartsheet/design-tokens";
import { checkboxBorderTheme } from "../checkboxTheme";
const getSize = props => props.size;
export const CheckmarkWrapper = styled("div")`
    // border color is managed from the CheckboxIcon component.
    border-width: ${_ref => {
  let {
    themeMode
  } = _ref;
  return themeMode.includes("ursa") ? border.width10 : border.width20;
}};
    border-style: solid;
    border-radius: ${_ref2 => {
  let {
    themeMode,
    size
  } = _ref2;
  return checkboxBorderTheme.borderRadius[size](themeMode);
}};

    box-sizing: border-box;
    height: var(--sds--checkbox--visual-size, ${getSize}px);
    width: var(--sds--checkbox--visual-size, ${getSize}px);

    flex: none;
`;
CheckmarkWrapper.displayName = "CheckboxWrapper";
//# sourceMappingURL=CheckmarkWrapper.js.map